export default __webpack_public_path__ + "static/healthcare-fraud-img-1-ba983b046197c6d72c25d91676de782f.svg";